import type { MealCart } from '../../../context/cart/CartContext.types';
import { fetchRest, HttpMethod } from '../rest.client';

export const useSduiService = () => {
    const addMeal = async (date: string, meal: MealCart) => {
        console.log('date', date, meal.inventoryId, meal.batchId);

        try {
            const result = await fetchRest({
                method: HttpMethod.POST,
                url: process.env.REACT_APP_SDUI_SERVICE_URL + `/menu/v2/cart/${date}/product/${meal.inventoryId}/`,
                body: {
                    quantity: 1,
                    entityId: meal.id
                }
            });

            console.log('result', result);
        } catch (error) {
            
        }
    };
    
    const removeMeal = async (date: string, meal: MealCart) => {
        console.log('date', date, meal.inventoryId, meal.batchId);

        try {
            const result = await fetchRest({
                method: HttpMethod.DELETE,
                url: process.env.REACT_APP_SDUI_SERVICE_URL + `/menu/v2/cart/${date}/product/${meal.inventoryId}/`,
                body: {
                    entityId: meal.id
                }
            });
            console.log('result', result);
        } catch (error) {
            
        }
    };

    return {
        addMeal,
        removeMeal
    };
};